/*
 * <alwan-coverage-calculator>: form, live result, wall preview and cart action.
 * Calculation lives in alwan-coverage-math.js (window.AlwanCoverage).
 * Add to cart goes through Ella's [data-btn-addtocart] handler so the quick cart opens as usual.
 */
(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('alwan-coverage-calculator')) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var MAX_DRAWN_PIECES = 900;
  var SHARE_PREFIX = 'c_';
  var SHARE_FIELDS = ['surface', 'unit', 'wall_w', 'wall_h', 'room_l', 'room_w', 'room_h', 'floor_l', 'floor_w', 'item_w', 'item_h', 'coverage', 'repeat', 'spare', 'door_count', 'door_w', 'door_h', 'window_count', 'window_w', 'window_h'];

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return values[key] != null ? values[key] : match;
    });
  }

  function unitWord(words, n) {
    if (!words) return '';
    if (n === 1) return words[0];
    if (n >= 2 && n <= 10) return words[1];
    return words[2];
  }

  // A product sold in packs (e.g. "مجموعة 12 بلاطة"): turn the piece count into packs and
  // recount the spare as the pieces left over from whole packs.
  function toPacks(result, pack) {
    if (!result.ok || !(pack > 1)) return result;
    var needed = result.quantity - (result.spare || 0);
    result.pieces = result.quantity;
    result.packSize = pack;
    result.quantity = Math.ceil(result.quantity / pack);
    result.spare = result.quantity * pack - needed;
    return result;
  }

  // Pack size stated in a title, e.g. "مجموعة 12 بلاطة" or "عدد 3 رول".
  function packFromTitle(title) {
    var m = window.AlwanCoverage.normalizeDigits(title || '').match(/(?:مجموعة|عدد|عبوة|باكو|كرتونة)\s*(?:من\s*)?(\d+)\s*(?:بلاط|قطع|قطعة|رول|ألواح|لوح|اعواد|أعواد|عود)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function num(n, digits) {
    return String(Number(Number(n).toFixed(digits == null ? 2 : digits)));
  }

  function money(cents, format) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format || window.money_format);
      }
    } catch (e) { /* fall through */ }
    return (cents / 100).toFixed(2);
  }

  function svg(tag, attrs) {
    var el = document.createElementNS(SVG_NS, tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (attrs[k] != null) el.setAttribute(k, attrs[k]);
    });
    return el;
  }

  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics must never break the calculator */ }
  }

  var uid = 0;

  class AlwanCoverageCalculator extends HTMLElement {
    connectedCallback() {
      if (this._ready || !window.AlwanCoverage) return;
      this._ready = true;
      this.C = window.AlwanCoverage;
      this.uid = 'ac' + (++uid);

      try {
        this.config = JSON.parse(this.querySelector('[data-calc-config]').textContent);
      } catch (e) {
        console.error('alwan-coverage-calculator: invalid config', e);
        return;
      }
      this.i18n = this.config.i18n || {};
      this.mode = this.config.mode;
      this.form = this.querySelector('[data-calc-form]');
      this.el = {
        empty: this.querySelector('[data-result-empty]'),
        error: this.querySelector('[data-result-error]'),
        body: this.querySelector('[data-result-body]'),
        qty: this.querySelector('[data-result-qty]'),
        unit: this.querySelector('[data-result-unit]'),
        spare: this.querySelector('[data-result-spare]'),
        cost: this.querySelector('[data-result-cost]'),
        notes: this.querySelector('[data-result-notes]'),
        preview: this.querySelector('[data-preview]'),
        tabs: this.querySelector('[data-preview-tabs]'),
        add: this.querySelector('[data-calc-add]'),
        cartQty: this.querySelector('[data-calc-cart-qty]'),
        cartForm: this.querySelector('[data-calc-cart-form]'),
        whatsapp: this.querySelector('[data-calc-whatsapp]'),
        share: this.querySelector('[data-calc-share]'),
        products: this.querySelector('[data-calc-products]'),
        productList: this.querySelector('[data-calc-product-list]'),
        collectionLink: this.querySelector('[data-calc-collection-link]'),
        disclosure: this.querySelector('[data-calc-disclosure]')
      };
      this.state = { rotated: false, surfaceIndex: 0, editing: false, result: null };
      this.productCache = {};

      if (this.mode === 'product') {
        this.applyProfile(this.config.profile, this.config.product.text);
      } else {
        this.applyPreset(this.currentPreset());
      }
      this.restoreFromUrl();
      this.bind();
      this.update();
    }

    // ---------------------------------------------------------------------
    // Setup
    // ---------------------------------------------------------------------

    field(name) {
      return this.form.elements[name];
    }

    value(name) {
      var f = this.field(name);
      return f ? f.value : '';
    }

    setValue(name, value) {
      var f = this.field(name);
      if (!f) return;
      if (f instanceof RadioNodeList) {
        Array.prototype.forEach.call(f, function (r) { r.checked = r.value === String(value); });
      } else if (f.type === 'checkbox') {
        f.checked = !!value;
      } else {
        f.value = value == null ? '' : value;
      }
    }

    currentPreset() {
      var key = this.value('material');
      var presets = this.config.presets || [];
      return presets.filter(function (p) { return p.key === key; })[0] || presets[0];
    }

    applyPreset(preset) {
      if (!preset) return;
      this.preset = preset;
      this.applyProfile(preset, null);
    }

    applyProfile(profile, text) {
      if (this.mode === 'product' && !(parseInt(profile.pack, 10) > 1)) {
        profile = Object.assign({}, profile, { pack: packFromTitle(this.config.product.title) });
      }
      this.profile = profile;
      var type = profile.type;
      var needsHeight = type !== 'floor_roll' && type !== 'area';
      var complete = function (d) { return !!(d && d.widthCm && (d.heightCm || !needsHeight)); };

      // Size priority: product metafields, then the product description, then customer input.
      var specs = { widthCm: this.C.measurementToCm(profile.width), heightCm: this.C.measurementToCm(profile.length || profile.height) };
      var described = text ? this.C.parseDimensions(text) : null;
      var source = 'missing';
      var dims = {
        widthCm: specs.widthCm || (described && described.widthCm),
        heightCm: specs.heightCm || (described && described.heightCm)
      };
      if (complete(dims)) {
        source = specs.widthCm || specs.heightCm ? 'specs' : 'description';
      }
      var w = (dims && dims.widthCm) || profile.default_w || '';
      var h = (dims && dims.heightCm) || profile.default_h || '';
      this.itemSource = this.mode === 'product' ? source : null;
      this.state.rotated = false;

      this.setValue('item_w', w);
      this.setValue('item_h', type === 'roll' && h ? num(h / 100) : h);
      this.setValue('coverage', profile.coverage || '');
      this.setValue('pattern', !!profile.pattern);
      this.setValue('repeat', profile.repeat || '');
      var spare = String(profile.spare || 0);
      this.setValue('spare', ['0', '5', '10', '15'].indexOf(spare) > -1 ? spare : '0');

      // Wall coverings are measured on walls only; floor rolls on the floor only.
      var allowed = type === 'floor_roll' ? ['floor'] : ['walls', 'wall'];
      this.querySelectorAll('[data-surface-option]').forEach(function (opt) {
        opt.hidden = allowed.indexOf(opt.getAttribute('data-surface-option')) === -1;
      });
      if (allowed.indexOf(this.value('surface')) === -1) this.setValue('surface', allowed[0]);

      var isRoll = type === 'roll';
      this.toggle('[data-item-w-field]', type !== 'area');
      this.toggle('[data-item-h-field]', type === 'tile' || isRoll);
      this.toggle('[data-item-coverage-field]', type === 'area');
      this.toggle('[data-pattern-field]', type === 'tile' || isRoll);
      this.toggle('[data-openings]', type === 'tile' || type === 'area');
      this.querySelector('[data-item-w-label]').textContent = isRoll || type === 'floor_roll' ? this.i18n.rollWidth : this.i18n.itemWidth;
      this.querySelector('[data-item-h-label]').textContent = isRoll ? this.i18n.rollLength : this.i18n.itemLength;
      this.querySelector('[data-item-h-suffix]').textContent = isRoll ? this.i18n.metre : this.i18n.cm;

      var summary = this.querySelector('[data-item-summary]');
      var showSummary = this.mode === 'product' && type !== 'area';
      summary.hidden = !showSummary;
      if (showSummary) {
        var src = this.querySelector('[data-item-source]');
        src.textContent = { specs: this.i18n.sourceSpecs, description: this.i18n.sourceDescription }[this.itemSource] || this.i18n.sourceMissing;
        src.classList.toggle('is-warning', this.itemSource === 'missing');
        // Without a known size the fields stay open so the customer enters it.
        this.setEditing(this.itemSource === 'missing');
        summary.querySelector('[data-item-size]').hidden = this.itemSource === 'missing';
      } else {
        this.setEditing(true);
      }
      this.syncSurfaceFields();
    }

    toggle(selector, show) {
      var el = this.querySelector(selector);
      if (el) el.hidden = !show;
    }

    setEditing(on) {
      this.state.editing = on;
      this.querySelector('[data-item-fields]').hidden = !on;
      var btn = this.querySelector('[data-item-edit]');
      if (btn) {
        btn.setAttribute('aria-expanded', String(on));
        btn.hidden = on;
      }
    }

    syncSurfaceFields() {
      var surface = this.value('surface');
      this.querySelectorAll('[data-fields]').forEach(function (el) {
        el.hidden = el.getAttribute('data-fields') !== surface;
      });
      var unitLabel = this.value('unit') === 'cm' ? this.i18n.cm : this.i18n.metre;
      this.querySelectorAll('[data-unit-suffix]').forEach(function (el) { el.textContent = unitLabel; });
      this.state.surfaceIndex = 0;
    }

    bind() {
      var self = this;
      var timer;
      var schedule = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { self.update(); }, 120);
      };

      this.form.addEventListener('input', schedule);
      this.form.addEventListener('change', function (e) {
        var name = e.target.name;
        if (name === 'material') {
          self.applyPreset(self.currentPreset());
        } else if (name === 'unit') {
          self.convertUnits(e.target.value);
          self.syncSurfaceFields();
        } else if (name === 'surface') {
          self.syncSurfaceFields();
        }
        self.update();
      });

      this.querySelectorAll('[data-wall]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.setAttribute('aria-pressed', String(btn.getAttribute('aria-pressed') !== 'true'));
          self.state.surfaceIndex = 0;
          self.update();
        });
      });

      var edit = this.querySelector('[data-item-edit]');
      if (edit) {
        edit.addEventListener('click', function () {
          self.setEditing(true);
          var input = self.field('item_w');
          if (input) input.focus();
        });
      }

      var rotate = this.querySelector('[data-rotate]');
      if (rotate) {
        rotate.addEventListener('click', function () {
          self.state.rotated = !self.state.rotated;
          rotate.setAttribute('aria-pressed', String(self.state.rotated));
          self.update();
        });
      }

      this.el.notes.addEventListener('click', function (e) {
        if (e.target.closest('[data-apply-rotate]')) {
          self.state.rotated = !self.state.rotated;
          if (rotate) rotate.setAttribute('aria-pressed', String(self.state.rotated));
          self.update();
        }
      });

      this.el.tabs.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-surface-index]');
        if (!tab) return;
        self.state.surfaceIndex = parseInt(tab.getAttribute('data-surface-index'), 10) || 0;
        self.renderPreview();
      });

      if (this.el.share) {
        this.el.share.addEventListener('click', function () { self.share(); });
      }

      if (this.el.add) {
        // Runs before Ella's delegated document handler, which then adds the item and opens the cart.
        this.el.add.addEventListener('click', function () {
          var r = self.state.result;
          if (!r || !r.ok) return;
          self.el.cartQty.value = r.quantity;
          var idInput = self.el.cartForm.querySelector('[name="id"]');
          var main = document.getElementById('product-form-' + self.config.product.id);
          var mainId = main && main.querySelector('[name="id"]');
          if (mainId && mainId.value) idInput.value = mainId.value;
          publish('alwan_calculator_add_to_cart', { product_id: self.config.product.id, quantity: r.quantity });
        });
        // Fallback when the theme script is unavailable: plain cart add, then go to the cart.
        this.el.cartForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var r = self.state.result;
          if (!r || !r.ok) return;
          var body = new FormData(self.el.cartForm);
          body.set('quantity', r.quantity);
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
            .then(function (res) { if (res.ok) window.location.href = (window.routes && window.routes.cart) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; });
        });
      }

      if (this.el.productList) {
        this.el.productList.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-btn-addtocart]');
          if (btn && btn.form) publish('alwan_calculator_add_to_cart', { variant_id: btn.form.elements.id.value, quantity: btn.form.elements.quantity.value, source: 'page' });
        });
      }
    }

    convertUnits(unit) {
      var factor = unit === 'cm' ? 100 : 0.01;
      var self = this;
      this.querySelectorAll('[data-unit-input]').forEach(function (input) {
        var n = self.C.parseNumber(input.value);
        if (isFinite(n)) input.value = num(n * factor, unit === 'cm' ? 1 : 3);
      });
    }

    // ---------------------------------------------------------------------
    // Calculation
    // ---------------------------------------------------------------------

    readInput() {
      var C = this.C;
      var unit = this.value('unit') === 'cm' ? 'cm' : 'm';
      var surface = this.value('surface');
      var self = this;
      var len = function (name) { return C.toCm(self.value(name), unit); };
      var required;
      var surfaces;

      if (surface === 'walls') {
        required = ['room_l', 'room_w', 'room_h'];
        var walls = Array.prototype.map.call(this.querySelectorAll('[data-wall]'), function (b) { return b.getAttribute('aria-pressed') === 'true'; });
        surfaces = C.buildSurfaces({ mode: 'walls', lengthCm: len('room_l'), roomWidthCm: len('room_w'), heightCm: len('room_h'), walls: walls });
        this.updatePlan(len('room_l'), len('room_w'), len('room_h'), unit);
      } else if (surface === 'floor') {
        required = ['floor_l', 'floor_w'];
        surfaces = C.buildSurfaces({ mode: surface, lengthCm: len('floor_l'), roomWidthCm: len('floor_w') });
      } else {
        required = ['wall_w', 'wall_h'];
        surfaces = C.buildSurfaces({ mode: 'wall', widthCm: len('wall_w'), heightCm: len('wall_h') });
      }

      var empty = required.some(function (name) { return !String(self.value(name)).trim(); });
      var type = this.profile.type;
      var w = C.parseNumber(this.value('item_w'));
      var h = C.parseNumber(this.value('item_h'));
      if (type === 'roll') h = h * 100;
      if (this.state.rotated && type === 'tile') { var t = w; w = h; h = t; }

      var openings = ['door', 'window'].map(function (o) {
        return { w: C.parseNumber(self.value(o + '_w')), h: C.parseNumber(self.value(o + '_h')), count: Math.max(0, Math.floor(C.parseNumber(self.value(o + '_count')) || 0)) };
      });

      // A piece much longer than any wall (a 5 m sticker roll) is cut into drops like wallpaper.
      if (type === 'tile' && h > 400) type = 'roll';

      return {
        empty: empty,
        input: {
          type: type,
          surfaces: surfaces,
          item: { w: w, h: h, coverageM2: C.parseNumber(this.value('coverage')) },
          patternMatch: !!(this.field('pattern') && this.field('pattern').checked),
          lockOrientation: !!this.profile.lock,
          repeatCm: C.parseNumber(this.value('repeat')) || 0,
          openings: openings,
          sparePct: parseInt(this.value('spare'), 10) || 0
        }
      };
    }

    // Room plan drawn to scale: walls 1 and 3 run along the length, 2 and 4 along the width.
    updatePlan(lengthCm, widthCm, heightCm, unit) {
      var self = this;
      var has = function (v) { return isFinite(v) && v > 0; };
      var show = function (cm) { return num(unit === 'cm' ? cm : cm / 100) + ' ' + (unit === 'cm' ? self.i18n.cm : self.i18n.metre); };
      var floor = this.querySelector('[data-plan-floor]');
      if (!floor) return;

      var ratio = has(lengthCm) && has(widthCm) ? Math.min(2.6, Math.max(0.6, lengthCm / widthCm)) : 4 / 3;
      floor.style.setProperty('--plan-ratio', ratio.toFixed(3));

      var selectedLength = 0;
      this.querySelectorAll('[data-wall]').forEach(function (btn, i) {
        var v = i % 2 === 0 ? lengthCm : widthCm;
        var on = btn.getAttribute('aria-pressed') === 'true';
        var label = btn.querySelector('[data-wall-size]');
        if (label) label.textContent = has(v) ? show(v) : '';
        if (on && has(v)) selectedLength += v;
      });

      var unitLabel = unit === 'cm' ? this.i18n.cm : this.i18n.metre;
      var plain = function (cm) { return num(unit === 'cm' ? cm : cm / 100); };
      this.querySelector('[data-plan-dims]').textContent = has(lengthCm) && has(widthCm) ? plain(lengthCm) + ' × ' + plain(widthCm) + ' ' + unitLabel : '';
      var area = this.querySelector('[data-plan-area]');
      area.textContent = selectedLength && has(heightCm) ? fill(this.i18n.wallsArea, { area: num((selectedLength * heightCm) / 10000, 1) }) : '';
    }

    update() {
      var read = this.readInput();
      var rotate = this.querySelector('[data-rotate]');
      var item = read.input.item;
      if (rotate) rotate.hidden = !(this.profile.type === 'tile' && !this.profile.lock && item.w && item.h && item.w !== item.h);
      var size = this.querySelector('[data-item-size]');
      if (size) {
        size.textContent = this.profile.type === 'floor_roll'
          ? num(item.w) + ' ' + this.i18n.cm
          : this.profile.type === 'roll'
            ? num(item.w) + ' ' + this.i18n.cm + ' × ' + num(item.h / 100) + ' ' + this.i18n.metre
            : num(item.w) + ' × ' + num(item.h) + ' ' + this.i18n.cm;
      }

      if (read.empty) {
        this.state.result = null;
        this.showState('empty');
        if (this.el.products) this.el.products.hidden = true;
        return;
      }

      var result = toPacks(this.C.calculate(read.input), parseInt(this.profile.pack, 10) || 0);
      this.state.result = result;
      this.state.input = read.input;

      if (!result.ok) {
        this.el.error.textContent = this.i18n.errors[result.error] || this.i18n.errors.surface_size;
        this.showState('error');
        if (this.el.products) this.el.products.hidden = true;
        return;
      }

      this.showState('result');
      this.renderResult(result, read.input);
      this.renderPreview();
      if (this.mode === 'page') this.renderProducts(read.input);
      this.updateShareUrl();
      if (!this._published) {
        this._published = true;
        publish('alwan_calculator_result', { type: result.type, quantity: result.quantity, mode: this.mode });
      }
    }

    showState(state) {
      this.el.empty.hidden = state !== 'empty';
      this.el.error.hidden = state !== 'error';
      this.el.body.hidden = state !== 'result';
    }

    unitLabel(n) {
      var key = (parseInt(this.profile.pack, 10) || 0) > 1 ? 'pack' : this.profile.unit_key;
      return unitWord(this.i18n.units[key] || this.i18n.units.piece, n);
    }

    pieceLabel(n) {
      return unitWord(this.i18n.units[this.profile.unit_key] || this.i18n.units.piece, n);
    }

    resultDisplay(r) {
      var panels = r.packSize && this.profile.unit_key === 'panel';
      var quantity = panels ? r.pieces : r.quantity;
      return { quantity: quantity, unit: panels ? this.pieceLabel(quantity) : this.unitLabel(quantity) };
    }

    renderResult(r, input) {
      var i18n = this.i18n;
      var unit = this.unitLabel(r.quantity);
      var display = this.resultDisplay(r);
      var panelPack = r.packSize && this.profile.unit_key === 'panel';
      if (this.el.qty.textContent !== String(display.quantity)) {
        this.el.qty.textContent = display.quantity;
        this.el.qty.style.animation = 'none';
        void this.el.qty.offsetWidth;
        this.el.qty.style.animation = '';
      }
      this.el.unit.textContent = display.unit;

      this.el.spare.hidden = !r.spare;
      this.el.spare.textContent = fill(panelPack ? i18n.packSpare : i18n.spare, { count: r.spare, unit: this.pieceLabel(r.spare) });

      var price = this.mode === 'product' ? this.config.product.price : null;
      this.el.cost.hidden = !price;
      if (price) this.el.cost.textContent = '≈ ' + money(price * r.quantity, this.config.moneyFormat);

      var notes = [];
      var L = r.layout;
      var packValues = { count: r.quantity, unit: unit, pieces: r.quantity * r.packSize, piece_unit: this.pieceLabel(r.quantity * r.packSize), pack: r.packSize, pack_unit: this.pieceLabel(r.packSize) };
      if (r.packSize) notes.push(fill(panelPack ? i18n.panelPackInfo : i18n.packInfo, packValues));
      if (r.type === 'tile') {
        if (r.naiveByArea != null && r.naiveByArea < r.base) notes.push(fill(i18n.naive, { naive: r.naiveByArea }));
        var full = 0, cut = 0;
        L.surfaces.forEach(function (s) { full += s.fullPieces; cut += s.cutPositions; });
        if (cut) notes.push(fill(i18n.cuts, { full: full, cut: cut }));
        if (L.autoRotated) notes.push(i18n.autoRotated);
        if (r.alternative) notes.push({ html: fill(i18n.rotate, { count: r.alternative.base }), action: i18n.rotateApply });
        if (r.saved) notes.push(fill(i18n.openings, { count: r.saved }));
      } else if (r.type === 'roll') {
        notes.push(fill(i18n.rollInfo, { drops: L.drops, drop: num(L.surfaces[0].dropCm, 0), per: L.dropsPerRoll }));
      } else if (r.type === 'floor_roll') {
        notes.push(fill(i18n.floorInfo, { strips: L.strips, length: num(L.stripCm / 100) }));
      }
      var sliver = null;
      (L.surfaces || []).some(function (s) { sliver = s.sliverW || s.sliverH; return !!sliver; });
      if (sliver) notes.push(fill(i18n.sliver, { edge: num(sliver.edgeCm, 1), centred: num(sliver.centredEdgeCm, 1) }));

      var list = this.el.notes;
      list.textContent = '';
      notes.forEach(function (n) {
        var li = document.createElement('li');
        if (typeof n === 'string') {
          li.textContent = n;
        } else {
          li.appendChild(document.createTextNode(n.html + ' '));
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'alwan-calc__link';
          b.setAttribute('data-apply-rotate', '');
          b.textContent = n.action;
          li.appendChild(b);
        }
        list.appendChild(li);
      });

      if (this.el.add) {
        var available = this.config.product.available;
        this.el.add.disabled = !available;
        this.el.add.textContent = available ? fill(panelPack ? i18n.addPanelsToCart : i18n.addToCart, panelPack ? packValues : { count: r.quantity, unit: unit }) : i18n.soldOut;
        this.el.cartQty.value = r.quantity;
      }

      var title = this.mode === 'product' ? this.config.product.title : '';
      var material = this.querySelector('input[name="material"]:checked + .alwan-calc__material-card .alwan-calc__material-name');
      if (material) title = material.textContent.trim();
      this.state.shareTitle = title;

      if (this.el.whatsapp) {
        var text = fill(i18n.whatsapp, {
          product: title,
          summary: this.describeInput(input),
          qty: display.quantity + ' ' + display.unit,
          link: this.shareUrl()
        });
        this.el.whatsapp.href = 'https://wa.me/' + encodeURIComponent(this.config.phone) + '?text=' + encodeURIComponent(text);
      }
    }

    describeInput(input) {
      var i18n = this.i18n;
      var m = function (cm) { return num(cm / 100) + ' ' + i18n.metre; };
      var surface = this.value('surface');
      var parts = [i18n.surfaceNames[surface] || ''];
      parts.push(input.surfaces.map(function (s) { return m(s.w) + ' × ' + m(s.h); }).join(' + '));
      if (this.profile.type === 'tile') parts.push(num(input.item.w) + ' × ' + num(input.item.h) + ' ' + i18n.cm);
      if (this.profile.type === 'roll') parts.push(num(input.item.w) + ' ' + i18n.cm + ' × ' + m(input.item.h));
      return parts.filter(Boolean).join(' • ');
    }

    // ---------------------------------------------------------------------
    // Preview
    // ---------------------------------------------------------------------

    renderPreview() {
      var r = this.state.result;
      if (!r || !r.ok) return;
      var surfaces = r.layout.surfaces || [];
      var idx = Math.min(this.state.surfaceIndex, surfaces.length - 1);
      var self = this;

      this.el.tabs.hidden = surfaces.length < 2;
      if (surfaces.length > 1) {
        this.el.tabs.textContent = '';
        var buttons = this.querySelectorAll('[data-wall]');
        var picked = Array.prototype.filter.call(buttons, function (b) { return b.getAttribute('aria-pressed') === 'true'; });
        surfaces.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'alwan-calc__tab';
          b.setAttribute('data-surface-index', i);
          b.setAttribute('aria-pressed', String(i === idx));
          var name = picked[i] && picked[i].querySelector('[data-wall-name]');
          var label = name ? name.textContent.trim() : String(i + 1);
          b.textContent = label;
          self.el.tabs.appendChild(b);
        });
      }

      var s = surfaces[idx];
      var canvas = this.el.preview;
      canvas.textContent = '';
      if (!s) return;

      var W = s.w, H = s.h;
      var root = svg('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img', preserveAspectRatio: 'xMidYMid meet', class: 'alwan-calc__svg' });
      root.setAttribute('aria-label', num(W / 100) + ' × ' + num(H / 100) + ' ' + this.i18n.metre);
      var hatchId = this.uid + '-hatch';
      var defs = svg('defs');
      var pattern = svg('pattern', { id: hatchId, width: 8, height: 8, patternUnits: 'userSpaceOnUse', patternTransform: 'rotate(45)' });
      var scale = Math.max(W, H) / 300;
      pattern.setAttribute('width', 8 * scale);
      pattern.setAttribute('height', 8 * scale);
      pattern.appendChild(svg('rect', { width: 8 * scale, height: 8 * scale, class: 'alwan-calc__cut-bg' }));
      pattern.appendChild(svg('line', { x1: 0, y1: 0, x2: 0, y2: 8 * scale, class: 'alwan-calc__cut-line', 'stroke-width': 3 * scale }));
      defs.appendChild(pattern);
      root.appendChild(defs);
      root.appendChild(svg('rect', { x: 0, y: 0, width: W, height: H, class: 'alwan-calc__wall' }));

      var cells = [];
      if (r.type === 'tile') {
        cells = this.gridCells(W, H, s.itemW, s.itemH, s.cols.count, s.rows.count);
      } else if (r.type === 'roll') {
        cells = this.gridCells(W, H, s.itemW, H, s.cols.count, 1);
      } else if (r.type === 'floor_roll') {
        cells = s.alongWidth
          ? this.gridCells(W, H, W, s.itemW, 1, s.strips)
          : this.gridCells(W, H, s.itemW, H, s.strips, 1);
      }

      if (cells.length > MAX_DRAWN_PIECES) {
        cells = [];
        var grid = svg('pattern', { id: this.uid + '-grid', width: s.itemW, height: s.itemH, patternUnits: 'userSpaceOnUse' });
        grid.appendChild(svg('rect', { width: s.itemW, height: s.itemH, class: 'alwan-calc__piece', 'vector-effect': 'non-scaling-stroke' }));
        defs.appendChild(grid);
        root.appendChild(svg('rect', { x: 0, y: 0, width: W, height: H, fill: 'url(#' + this.uid + '-grid)' }));
      }

      cells.forEach(function (c) {
        root.appendChild(svg('rect', {
          x: c.x, y: c.y, width: c.w, height: c.h,
          class: c.cut ? 'alwan-calc__piece alwan-calc__piece--cut' : 'alwan-calc__piece',
          style: c.cut ? 'fill: url(#' + hatchId + ')' : null,
          'vector-effect': 'non-scaling-stroke'
        }));
      });
      root.appendChild(svg('rect', { x: 0, y: 0, width: W, height: H, class: 'alwan-calc__wall-edge', 'vector-effect': 'non-scaling-stroke' }));
      canvas.appendChild(root);

      var dims = document.createElement('p');
      dims.className = 'alwan-calc__dims alwan-ltr';
      dims.textContent = num(W / 100) + ' × ' + num(H / 100) + ' ' + this.i18n.metre;
      canvas.appendChild(dims);
    }

    // Pieces laid from the bottom-right corner (RTL start), so the cut column ends up
    // on the left and the cut row at the top, where installers usually finish.
    gridCells(W, H, iw, ih, cols, rows) {
      var out = [];
      for (var r = 0; r < rows; r++) {
        var y = H - (r + 1) * ih;
        var h = ih;
        if (y < 0) { h = ih + y; y = 0; }
        for (var c = 0; c < cols; c++) {
          var x = W - (c + 1) * iw;
          var w = iw;
          if (x < 0) { w = iw + x; x = 0; }
          if (w <= 0 || h <= 0) continue;
          out.push({ x: x, y: y, w: w, h: h, cut: w < iw - 0.5 || h < ih - 0.5 });
        }
      }
      return out;
    }

    // ---------------------------------------------------------------------
    // Page mode: products from the selected material's collection
    // ---------------------------------------------------------------------

    renderProducts(input) {
      var preset = this.preset;
      var box = this.el.products;
      if (!box || !preset || !preset.collection) {
        if (box) box.hidden = true;
        return;
      }
      box.hidden = false;
      if (this.el.collectionLink) this.el.collectionLink.href = preset.collectionUrl || '#';
      var self = this;
      var handle = preset.collection;
      var token = (this._productToken = {});
      this.loadProducts(handle).then(function (products) {
        if (token !== self._productToken) return;
        self.drawProducts(products, input, preset);
      }).catch(function () {
        if (token !== self._productToken) return;
        self.el.productList.innerHTML = '';
        var li = document.createElement('li');
        li.className = 'alwan-calc__product-error';
        li.textContent = self.i18n.productsError;
        self.el.productList.appendChild(li);
      });
    }

    loadProducts(handle) {
      if (!this.productCache[handle]) {
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        this.productCache[handle] = fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=8', { headers: { Accept: 'application/json' } })
          .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
          .then(function (data) { return data.products || []; });
      }
      return this.productCache[handle];
    }

    drawProducts(products, input, preset) {
      var C = this.C;
      var list = this.el.productList;
      var self = this;
      list.textContent = '';

      products.forEach(function (p) {
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        if (!variant) return;
        var text = p.title + ' . ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ');
        var dims = C.parseDimensions(text);
        // Products whose copy states a size use it; others use the size the customer entered,
        // and only verified sizes get an add-to-cart button.
        var item = { w: input.item.w, h: input.item.h, coverageM2: input.item.coverageM2 };
        var known = preset.type === 'area';
        if (dims && dims.widthCm && (dims.heightCm || preset.type === 'floor_roll')) {
          item.w = dims.widthCm;
          if (preset.type !== 'floor_roll') item.h = dims.heightCm;
          if (self.state.rotated && preset.type === 'tile') { var t = item.w; item.w = item.h; item.h = t; }
          known = true;
        }
        var pack = packFromTitle(p.title);
        var r = toPacks(C.calculate(Object.assign({}, input, { item: item })), pack);
        var unitKey = pack > 1 ? 'pack' : preset.unit_key;
        var cents = Math.round(parseFloat(variant.price) * 100);

        var li = document.createElement('li');
        li.className = 'alwan-calc__product product-item';
        var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + p.handle;

        var link = document.createElement('a');
        link.className = 'alwan-calc__product-link';
        link.href = url;
        var img = (p.images || [])[0];
        if (img) {
          var im = document.createElement('img');
          im.src = img.src + (img.src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          im.alt = '';
          im.loading = 'lazy';
          im.width = 80;
          im.height = 80;
          link.appendChild(im);
        }
        var info = document.createElement('span');
        info.className = 'alwan-calc__product-info';
        var name = document.createElement('span');
        name.className = 'alwan-calc__product-name';
        name.textContent = p.title;
        info.appendChild(name);
        var need = document.createElement('span');
        need.className = 'alwan-calc__product-need';
        if (r.ok) {
          need.textContent = fill(self.i18n.productsNeed, { qty: r.quantity, unit: unitWord(self.i18n.units[unitKey] || self.i18n.units.piece, r.quantity), cost: money(cents * r.quantity, self.config.moneyFormat) });
          if (!known) need.textContent += ' • ' + self.i18n.productsSizeUnknown;
        } else {
          need.textContent = money(cents, self.config.moneyFormat);
        }
        info.appendChild(need);
        link.appendChild(info);
        li.appendChild(link);

        if (preset.addToCart && known && r.ok && variant.available) {
          var form = document.createElement('form');
          form.className = 'alwan-calc__product-form';
          form.action = (window.routes && window.routes.cart_add_url) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add';
          form.method = 'post';
          form.innerHTML = '<input type="hidden" name="id"><input type="hidden" name="quantity">';
          form.elements.id.value = variant.id;
          form.elements.quantity.value = r.quantity;
          var btn = document.createElement('button');
          btn.type = 'submit';
          btn.className = 'alwan-button alwan-button--primary alwan-calc__product-add';
          btn.setAttribute('data-btn-addtocart', '');
          btn.textContent = fill(self.i18n.addToCart, { count: r.quantity, unit: unitWord(self.i18n.units[unitKey] || self.i18n.units.piece, r.quantity) });
          form.appendChild(btn);
          li.appendChild(form);
        }
        list.appendChild(li);
      });
    }

    // ---------------------------------------------------------------------
    // Share link (dimensions only, no personal data)
    // ---------------------------------------------------------------------

    shareUrl() {
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (k) { if (k.indexOf(SHARE_PREFIX) === 0) url.searchParams.delete(k); });
      var self = this;
      SHARE_FIELDS.forEach(function (name) {
        var v = self.value(name);
        var opening = name.match(/^(door|window)_[wh]$/);
        if (opening && !(parseInt(self.value(opening[1] + '_count'), 10) > 0)) return;
        if (/_count$/.test(name) && !(parseInt(v, 10) > 0)) return;
        if (v !== '' && v != null) url.searchParams.set(SHARE_PREFIX + name, v);
      });
      if (this.field('pattern')) url.searchParams.set(SHARE_PREFIX + 'pattern', this.field('pattern').checked ? '1' : '0');
      if (this.state.rotated) url.searchParams.set(SHARE_PREFIX + 'rot', '1');
      if (this.value('surface') === 'walls') {
        url.searchParams.set(SHARE_PREFIX + 'walls', Array.prototype.map.call(this.querySelectorAll('[data-wall]'), function (b) { return b.getAttribute('aria-pressed') === 'true' ? '1' : '0'; }).join(''));
      }
      if (this.mode === 'page' && this.preset) url.searchParams.set(SHARE_PREFIX + 'material', this.preset.key);
      url.hash = this.id;
      return url.toString();
    }

    updateShareUrl() {
      clearTimeout(this._urlTimer);
      var self = this;
      this._urlTimer = setTimeout(function () {
        try { history.replaceState(history.state, '', self.shareUrl()); } catch (e) { /* ignore */ }
      }, 600);
    }

    restoreFromUrl() {
      var params = new URLSearchParams(window.location.search);
      if (!params.has(SHARE_PREFIX + 'surface')) return;
      var self = this;
      var get = function (k) { return params.get(SHARE_PREFIX + k); };

      if (this.mode === 'page' && get('material')) {
        this.setValue('material', get('material'));
        this.applyPreset(this.currentPreset());
      }
      if (get('unit') === 'cm' && this.value('unit') !== 'cm') this.convertUnits('cm');
      SHARE_FIELDS.forEach(function (name) {
        var v = get(name);
        if (v != null) self.setValue(name, v);
      });
      if (get('pattern') != null && this.field('pattern')) this.field('pattern').checked = get('pattern') === '1';
      this.state.rotated = get('rot') === '1';
      var walls = get('walls');
      if (walls) {
        this.querySelectorAll('[data-wall]').forEach(function (b, i) { b.setAttribute('aria-pressed', String(walls.charAt(i) !== '0')); });
      }
      if (this.mode === 'product' && this.itemSource !== 'missing' && (get('item_w') || get('item_h'))) {
        this.setEditing(true);
      }
      this.syncSurfaceFields();
      if (this.el.disclosure) this.el.disclosure.open = true;
      if (window.location.hash === '#' + this.id) {
        var target = this;
        setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 300);
      }
    }

    // Native share sheet where available (phones, most tablets); otherwise copy the link.
    share() {
      var url = this.shareUrl();
      var r = this.state.result;
      var i18n = this.i18n;
      var label = this.el.share.querySelector('[data-share-label]');
      var display = r && r.ok ? this.resultDisplay(r) : null;
      var text = display ? fill(i18n.shareText, { product: this.state.shareTitle || '', qty: display.quantity + ' ' + display.unit }) : '';
      publish('alwan_calculator_share', { mode: this.mode });
      if (navigator.share) {
        navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
        return;
      }
      var copied = function () {
        label.textContent = i18n.copied;
        setTimeout(function () { label.textContent = i18n.share; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied, function () { window.prompt('', url); });
      } else {
        window.prompt('', url);
      }
    }
  }

  customElements.define('alwan-coverage-calculator', AlwanCoverageCalculator);
})();
